'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventProps = undefined;

var _reselect = require('reselect');

var _getPopOpenWelcomeMessage = require('../../selectors/widgetDataSelectors/getPopOpenWelcomeMessage');

var _getIsBot = require('../../selectors/widgetDataSelectors/getIsBot');

var _getUrlForMessage = require('../../utils/getUrlForMessage');

var _widgetState = require('./widgetState');

var eventProps = exports.eventProps = (0, _reselect.createSelector)([_widgetState.widgetState, _getIsBot.getIsBot, _getPopOpenWelcomeMessage.getPopOpenWelcomeMessage], function (state, botEnabled, promptEnabled) {
  return {
    state: state,
    botEnabled: botEnabled,
    promptEnabled: promptEnabled,
    path: (0, _getUrlForMessage.getUrlForMessage)()
  };
});


//////////////////
// WEBPACK FOOTER
// ./js/usage-tracking/selectors/eventProps.js
// module id = 761
// module chunks = 2 3